import { CopyLinkButton } from '@components/incentives/copy-link-button';
import { PreviewLinkButton } from '@components/incentives/preview-link-button';
import { Stack } from '@mui/system';
import { FunctionComponent } from 'react';

export type DonorActionBarProps = {
  url: string;
};

export const DonorActionBar: FunctionComponent<DonorActionBarProps> = (
  props,
) => {
  const { url } = props;

  return (
    <Stack direction="row" justifyContent="flex-end" spacing={1}>
      <CopyLinkButton text={url} />
      <PreviewLinkButton url={url} />
    </Stack>
  );
};
